/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_TitleInputs */

const en_settings_tickets_title = /** @type {(inputs: Settings_Tickets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Tickets`)
};

const zh_settings_tickets_title = /** @type {(inputs: Settings_Tickets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单支持`)
};

/**
* | output |
* | --- |
* | "Support Tickets" |
*
* @param {Settings_Tickets_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_title = /** @type {((inputs?: Settings_Tickets_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_title(inputs)
	return zh_settings_tickets_title(inputs)
});
export { settings_tickets_title as "settings.tickets.title" }